module.exports = __webpack_public_path__ + "img/lens-174-minus-07.9278fefe.png";